"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingUrlParameter = exports.SignupUrlParameter = void 0;
var SignupUrlParameter;
(function (SignupUrlParameter) {
    SignupUrlParameter["PLAN_PREFERENCE"] = "planp";
    SignupUrlParameter["PLAN"] = "plan";
    SignupUrlParameter["CLOUD_PREFERENCE"] = "cloudp";
    SignupUrlParameter["CLOUD"] = "cloud";
    SignupUrlParameter["REGION_PREFERENCE"] = "regionp";
    SignupUrlParameter["REGION"] = "region";
    SignupUrlParameter["OWNER"] = "owner";
    SignupUrlParameter["ENG"] = "eng";
    SignupUrlParameter["AMPT"] = "ampt";
    SignupUrlParameter["SDM"] = "SDM";
    SignupUrlParameter["TRIAL"] = "trial";
    SignupUrlParameter["LISTING"] = "listing";
    SignupUrlParameter["REFERRER"] = "referrer";
    SignupUrlParameter["ABEXPERIMENT"] = "abexperiment";
    SignupUrlParameter["ACCOUNT"] = "account";
    SignupUrlParameter["AWSMP"] = "awsmp";
    SignupUrlParameter["LAB"] = "lab";
    SignupUrlParameter["TEMPLATE"] = "template";
    SignupUrlParameter["WORKSPACES"] = "workspaces";
    SignupUrlParameter["INTEGRATION_TEST"] = "integrationTest";
    SignupUrlParameter["FIRSTNAME"] = "firstname";
    SignupUrlParameter["LASTNAME"] = "lastname";
    SignupUrlParameter["EMAIL"] = "email";
    SignupUrlParameter["E6CCEE4CEB"] = "E6CCEE4CEB";
    SignupUrlParameter["TOKEN"] = "token";
    SignupUrlParameter["T"] = "t";
    SignupUrlParameter["PROGRAM"] = "program";
})(SignupUrlParameter || (exports.SignupUrlParameter = SignupUrlParameter = {}));
var MarketingUrlParameter;
(function (MarketingUrlParameter) {
    MarketingUrlParameter["UTM_ADGROUP"] = "utm_adgroup";
    MarketingUrlParameter["UTM_SOURCE"] = "utm_source";
    MarketingUrlParameter["UTM_MEDIUM"] = "utm_medium";
    MarketingUrlParameter["UTM_CAMPAIGN"] = "utm_campaign";
    MarketingUrlParameter["UTM_CONTENT"] = "utm_content";
    MarketingUrlParameter["UTM_TERM"] = "utm_term";
    MarketingUrlParameter["UTM_REGION"] = "utm_region";
    MarketingUrlParameter["GCLID"] = "gclid";
})(MarketingUrlParameter || (exports.MarketingUrlParameter = MarketingUrlParameter = {}));
//# sourceMappingURL=urlParams.js.map